// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ServerError from "../Error/ServerError";
import SectionLeft from "./SectionLeft";
import SectionRight from "./SectionRight";

// CONFIGURAZIONI
import { appConfig, AGENCY_ID } from "../../config/appConfig";


const Services: React.FC = () => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);

    const imgSrc = '/assets/images/c24.png';
    const imgAlt = t('widgets.partners.c24LogoAlt', 'Logo Casain24ore');
    const url = agency ? `http://www.casain24ore.it/fromsito.php?agReg=${AGENCY_ID}` : '#';

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>

            <Helmet>
                <title>{t('navigation.servicesLinkTitle')} | {agency?.agencyName ?? t('common.defaultAgencyName')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={false}/>

            <section className="space-ptb">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="row justify-content-center align-items-center">

                                <SectionRight
                                    image={t('servicesPage.image1.image')}
                                    imageAlt={t('servicesPage.image1.imageAlt')}
                                    bullets={[t('servicesPage.image1.bullet1'), t('servicesPage.image1.bullet2'), t('servicesPage.image1.bullet3')]}
                                />

                                <SectionLeft
                                    image={t('servicesPage.image2.image')}
                                    imageAlt={t('servicesPage.image2.imageAlt')}
                                    bullets={[t('servicesPage.image2.bullet1'), t('servicesPage.image2.bullet2'), t('servicesPage.image2.bullet3'), t('servicesPage.image2.bullet4')]}
                                />

                            </div>
                            <div className="text-center mt-4">
                                <h3>{t('servicesPage.subParagraph.firstRow')}<br />{t('servicesPage.subParagraph.secondRow')}</h3>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar">
                                <WidgetContacts
                                    agencyDataAddress={agency?.address_details?.address ?? ''}
                                    agencyDataCity={agency?.address_details?.city_name ?? ''}
                                    agencyDataComuneCapoluogo={false}
                                    agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                    agencyDataEmail={appConfig.agency.agencyEmail}
                                    agencyDataEmailShow={appConfig.ui.agencyWidget.showEmail}
                                    agencyDataPhone1={agency?.phone1 ?? ''}
                                    agencyDataPhone2={agency?.phone2 ?? ''}
                                    agencyDataInternationalPrefix="+39"
                                    agencyDataMobile={agency?.mobile ?? ''}
                                    // agencyDataMobile2={agency?.mobile2 ?? ''} // Opzionale
                                    // agencyDataFax={agency?.fax ?? ''} // Opzionale
                                    // agencyDataWhatsapp="123456789" // Da configurare
                                    // Dati social da configurare o passare dinamicamente
                                    agencyDataFacebook="#"
                                    agencyDataInstagram="#"
                                    agencyDataTwitter="#"
                                    agencyDataLinkedin="#"
                                    agencyDataPinterest="#"
                                />
                                <WidgetPartners
                                    partners={[
                                        {
                                            url: url,
                                            data: {
                                                imgSrc: imgSrc,
                                                imgAlt: imgAlt,
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default Services;